import {appComponent} from '../app.component';
import {CmsContentComponent} from '../cms/cms-content/cms-content.component';
import {EmailService} from '../email/email.service';
import {FetchService} from '../fetch/fetch.service';

new CmsContentComponent(new EmailService(new FetchService()), appComponent.usersService);
